module.exports = __webpack_public_path__ + "static/media/4.fd267648.jpg";